/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by: scripts/generate-template-loaders.js
 * Source files:
 *   - business-report.njk
 *   - business-report.css
 */

export const BUSINESS_REPORT_TEMPLATE = `<div class="report-wrapper">
  <div class="report-brand-header">
    <div>
      <h2 class="company-title">{{ companyName }}</h2>
      {% if address %}
        <p class="company-sub">{{ address }}</p>
      {% endif %}
      {% if phone or email %}
        <p class="company-sub">
          {% if phone %}{{ phone }}{% endif %}
          {% if phone and email %} | {% endif %}
          {% if email %}{{ email }}{% endif %}
        </p>
      {% endif %}
    </div>
    <div class="header-right">
      <span class="badge-report">Business Report</span>
      <p class="meta-time">Generated: <strong>{{ generatedAt }}</strong></p>
    </div>
  </div>

  <div class="report-title-section">
    <h1 class="report-main-title">{{ title }}</h1>
    {% if description %}
      <p class="report-desc">{{ description }}</p>
    {% endif %}
  </div>

  <div class="report-filter-bar">
    <span><strong>Stores Filtered:</strong> {{ selectedStoresLabel }}</span>
    <span><strong>Date:</strong> {{ dateLabel }}</span>
  </div>

  {% if stats and stats.length > 0 %}
    <div class="report-stats-grid">
      {% for item in stats %}
        <div class="report-stat-card">
          <div class="report-stat-title">{{ item.title }}</div>
          <div class="report-stat-value">{{ item.value }}</div>
        </div>
      {% endfor %}
    </div>
  {% endif %}

  <div class="report-body">
    {{ reportHtmlContent | safe }}
  </div>

  <div class="report-footer">
    <div>Confidential - Internal Business Report</div>
    <div>{{ companyName }} • {{ title }}</div>
  </div>
</div>
`;

export const BUSINESS_REPORT_CSS = `@page {
  margin: 10mm;
}

*, *:before, *:after {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f172a;
  -webkit-font-smoothing: antialiased;
}

.report-wrapper {
  width: 100%;
  margin: 0 auto;
  background: #ffffff;
}

/* Brand Header */
.report-brand-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 2.5px solid #4f46e5;
  padding-bottom: 12px;
  margin-bottom: 14px;
}

.company-title {
  font-size: 19px;
  font-weight: 800;
  color: #1e1b4b;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: -0.3px;
}

.company-sub {
  font-size: 10.5px;
  color: #64748b;
  margin: 2px 0 0 0;
}

.header-right {
  text-align: right;
}

.badge-report {
  display: inline-block;
  padding: 3px 10px;
  background-color: #e0e7ff;
  color: #3730a3;
  font-size: 9px;
  font-weight: 700;
  border-radius: 9999px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.meta-time {
  font-size: 10px;
  color: #64748b;
  margin: 4px 0 0 0;
}

/* Title Section */
.report-title-section {
  margin-bottom: 12px;
}

.report-main-title {
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: -0.2px;
}

.report-desc {
  font-size: 11px;
  color: #475569;
  margin: 3px 0 0 0;
}

/* Filter Meta Bar */
.report-filter-bar {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 7px 12px;
  margin-bottom: 14px;
  font-size: 10px;
  color: #334155;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Stats Cards */
.report-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  gap: 10px;
  margin-bottom: 16px;
}

.report-stat-card {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 8px 10px;
}

.report-stat-title {
  font-size: 8.5px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 2px;
}

.report-stat-value {
  font-size: 13px;
  font-weight: 800;
  color: #0f172a;
}

/* Table Styling for Clean Output */
table {
  width: 100% !important;
  border-collapse: collapse !important;
  margin-bottom: 14px !important;
  font-size: 10px !important;
  table-layout: auto !important;
}

th, td {
  padding: 6px 8px !important;
  border: 1px solid #cbd5e1 !important;
  text-align: left;
  white-space: normal !important;
  word-break: break-word !important;
}

th {
  background-color: #f1f5f9 !important;
  color: #1e293b !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  font-size: 9px !important;
  letter-spacing: 0.3px !important;
}

tr:nth-child(even) td {
  background-color: #f8fafc;
}

/* Hide all UI elements & paginations */
.no-print, .ant-pagination, .ant-table-pagination, .ant-pagination-options, .ant-btn, .ant-select, .ant-input-search, button {
  display: none !important;
}

/* Footer */
.report-footer {
  margin-top: 20px;
  border-top: 1px solid #e2e8f0;
  padding-top: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 9px;
  color: #94a3b8;
}
`;
